'use client';
'use strict';

var TextTab_parts = require('./TextTab.parts.js');

/**
 * @module TextTab
 * @description 텍스트 기반의 탭 네비게이션 컴포넌트입니다.
 * @property {Component} Root - 탭 컨테이너
 * @property {Component} Tabs - 탭 목록
 * @property {Component} Tab - 탭
 * @property {Component} Panel - 탭 패널
 * @example
 * // 기본 사용법
 * import TextTab from './TextTab';
 *
 * function Example() {
 *   return (
 *     <TextTab.Root defaultValue="tab1">
 *       <TextTab.Tabs>
 *         <TextTab.Tab value="tab1">첫 번째 탭</TextTab.Tab>
 *         <TextTab.Tab value="tab2">두 번째 탭</TextTab.Tab>
 *       </TextTab.Tabs>
 *
 *       <TextTab.Panel value="tab1">
 *         첫 번째 탭 내용
 *       </TextTab.Panel>
 *       <TextTab.Panel value="tab2">
 *         두 번째 탭 내용
 *       </TextTab.Panel>
 *     </TextTab.Root>
 *   );
 * }
 */ const TextTab = {
    Root: TextTab_parts.Root,
    Tabs: TextTab_parts.Tabs,
    Tab: TextTab_parts.Tab,
    Panel: TextTab_parts.Panel
};

module.exports = TextTab;
